export default __webpack_public_path__ + "static/media/project.8fd16481.jpg";